module.exports = __webpack_public_path__ + "img/6000.7f311d31.jpg";